export default __webpack_public_path__ + "static/media/ico-wifi-shared.7ec1c191.svg";